const BlueBox4i = function(){
	const bbSuggestion = new BlueBoxSuggestion(); // in modules folder
	const trendScroller = new prodScroller();
	const common = new bbCommon();
	const starRatingJS = new StarRating4i();
	starRatingJS.Init();

	const init = async () =>{
		const yesBtn = document.getElementById("yesBox");
		if(yesBtn) yesBtn.disabled = false;
		
		if (document.getElementById("trendingProducts")) await trendScroller.Init("trendingProducts", 5, 4, 3); //numbers are # items shown per breakpoint
		document.addEventListener("click", bbEvents);
	};	

	const bbEvents = (e) =>{
		if(e.target.id == "submitSuggestion"){
			e.preventDefault();
			bbSuggestion.Send();
		}else if(e.target.id == "cancelBoxSuggestion"){
			e.preventDefault();
			bbSuggestion.Cancel();
		}
	};

	return{
		Init: init
	};
};

(async () =>{
	const blueBox = new BlueBox4i();
	blueBox.Init();
})();